<template>
  <div>
    <a-drawer :title="`${actType}素材`" :width="720" :visible="showForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">
        <a-form-model-item label="目录" prop="pid" v-if="treeData.length > 0">
          <a-tree-select v-model="model.pid" style="width: 100%" placeholder="根目录" allow-clear :tree-data="treeData" :disabled='model.action?true:false'
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>

        <a-form-model-item label="上传人" prop="worker_id" v-if="!model.action">
          <a-select placeholder="请选择" allow-clear show-search :default-value="model.worker_id" v-model="model.worker_id" option-filter-prop="children">
              <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                  {{ worker.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item :label="actionName+'后名称'" prop="name" v-if="model.action">
          <a-input v-model="model.name" />
        </a-form-model-item>
        
        <a-form-model-item label="选择的目录" prop="pid" v-if="model.action">
          <a-tree-select v-model="pid" style="width: 100%" placeholder="根目录" allow-clear :tree-data="treeData" 
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>

        <template v-if="!model.action">

            <template v-if="!(materials && materials.length<=1)">
                <a-form-model-item v-if="!model.id" label="素材" class="upload-model-item" prop="file_url"
                help="横版视频：宽高比 16:9，大小≤1000M，分辨率≥1280*720, 时长 > 3s ｜ 竖版视频：宽高比 9:16，大小≤1000M，分辨率≥720*1280, 时长 > 3s">
                <oss-upload v-model="model.file_url" @afterUpload="handleAfterUpload" />
                </a-form-model-item>
            </template>

            <template v-else>
                  <a-form-model-item v-if="!model.id" label="素材" class="upload-model-item" prop="file_url"
                  help="横版视频：宽高比 16:9，大小≤1000M，分辨率≥1280*720, 时长 > 3s ｜ 竖版视频：宽高比 9:16，大小≤1000M，分辨率≥720*1280, 时长 > 3s">
                  <oss-upload v-model="model.file_url" @afterUpload="handleAfterUpload" />
                  </a-form-model-item>

                  <a-form-model-item label="图片信息" v-else-if="model.id && model.type == 2">
                      <img :src="model.file_url"  style="height:300px">
                  </a-form-model-item>
      
                
                  <template v-else-if="model.type == 3">
                    
                    <a-form-model-item v-if="!model.id" label="素材" class="upload-model-item" prop="file_url"
                    help="横版视频：宽高比 16:9，大小≤1000M，分辨率≥1280*720, 时长 > 3s ｜ 竖版视频：宽高比 9:16，大小≤1000M，分辨率≥720*1280, 时长 > 3s">
                    <oss-upload v-model="model.file_url" @afterUpload="handleAfterUpload" />
                  </a-form-model-item>
      
      
                    <a-form-model-item v-if="model.file_url" label="视频">
                      <video  controls style="width: 70%" :src="model.file_url"  ref="video" controlslist="nodownload noremoteplayback"/>
                    </a-form-model-item>
      
                    <a-form-model-item v-if="model.id && model.video_cover" label="视频默认封面图">
                      <img :src="model.video_cover" style="height:200px">
                    </a-form-model-item>
                  
                    <a-form-model-item v-if="model.id && model.video_cover"  label="视频自定义封面图" class="upload-model-item" prop="video_custom_cover">
                        <image-upload v-model="model.video_custom_cover" />
                    </a-form-model-item>
                  </template>
      
                  
                  <a-form-model-item v-else label="素材" class="upload-model-item" prop="file_url"
                    help="横版视频：宽高比 16:9，大小≤1000M，分辨率≥1280*720, 时长 > 3s ｜ 竖版视频：宽高比 9:16，大小≤1000M，分辨率≥720*1280, 时长 > 3s">
                    <oss-upload v-model="model.file_url" @afterUpload="handleAfterUpload" />
                  </a-form-model-item>
      
      
                  <a-form-model-item label="素材名称" prop="name" help="上传后自动改为文件名称">
                    <a-input v-model="model.name" />
                  </a-form-model-item>

                  <a-form-model-item label="素材标签" prop="material_tag_ids">
                    <a-select mode="multiple" show-search allow-clear placeholder="请选择" v-model="model.material_tag_ids"
                      option-filter-prop="children">
                      <a-select-option :value="item.id" v-for="item in materialTags" :key="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
      
                  <a-form-model-item v-if="model.size" label="大小" >
                    <a-input v-model="showSize" disabled suffix="M" />
                  </a-form-model-item>
      
                  <a-form-model-item v-if="model.width" label="宽度" >
                    <a-input v-model="model.width" disabled suffix="像素"/>
                  </a-form-model-item>
      
                  <a-form-model-item v-if="model.height" label="高度" >
                    <a-input v-model="model.height" disabled suffix="像素"/>
                  </a-form-model-item>
      
                  <a-form-model-item label="备注" prop="remark">
                    <a-textarea v-model="model.remark" placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" />
                  </a-form-model-item>

                  
            </template>




        </template>
       


      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
